import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    // backgroundColor: 'black',
  },
  spaceHeader: {
    marginTop: 45,
  },
  quest: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    alignSelf: 'center',
    marginTop: 80,
  },
  contact: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    maxWidth: 280,
    alignSelf: 'center',
    marginTop: 10,
  },
  atention: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: Colors.RedPallete.red,
    marginBottom: 10,
  },
  phone: {
    marginTop: 50,
    alignSelf: 'center',
    fontSize: 22,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 26,
    color: Colors.GrayPallete.lightgrayThree,
  },
  service: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    alignSelf: 'center',
    marginBottom: 10,
    marginTop: 10,
    color: Colors.GrayPallete.lightgrayThree,
  },
  desativarConta: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    alignSelf: 'center',
    marginBottom: 20,
    marginTop: 10,
    color: Colors.GrayPallete.lightgrayThree,
  },
  spaceXY: {
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  container: {
    marginTop: 40,
  },
  title: {
    fontSize: 16,
    lineHeight: 19,
    color: 'black',
    fontFamily: 'TCCC-UnityText Bold',
    marginBottom: 30,
  },
  image: {
    alignSelf: 'center',
  },
  imageSize: {
    textAlign: 'center',
    alignSelf: 'center',
    maxWidth: 250,
    color: Colors.GrayPallete.lightgrayThree,
    fontFamily: 'TCCC-UnityHeadline Regular',
    marginTop: 20,
  },
  containerButton: {
    marginTop: 30,
  },
  containerInput: {
    paddingHorizontal: 40,
    marginTop: 30,
  },
  acept: {
    fontSize: 14,
    lineHeight: 16,
    color: 'black',
    fontFamily: 'TCCC-UnityText Bold',
    marginBottom: 20,
  },
});
